import { Button, Grid, Typography } from '@mui/material'
import React, { useRef, useState } from 'react'
import { useStyle } from '../style'
import { Delete, ExitToApp, NoteAdd, Print, Save } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import axios from 'axios'
import PaymentInfo from './PaymentInfo'
import BillingTable from './billingTable'
import { useDispatch } from 'react-redux'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
import { Helmet } from 'react-helmet-async'
import DialogCancel from '../../../../../components/utils/dialogCancel/dialogCancel'

const Payment = () => {
    const classes = useStyle()
    const dispatch = useDispatch()
    const codeRef = useRef(null)
    const [data, setData] = useState([])
    const [code,setCode] = useState('')
      const [dialogClose, setDialogClose] = useState(false);
    
    const navigate = useNavigate()
    const [postData , setPostData] = useState({
        date: moment().format('YYYY/MM/DD'),
        supplierid: 0,
        mode:null,
        amount: 0,
        chequeno: "",
        chequedate: moment().format('YYYY/MM/DD'),
        bank:"",
        discount: 0,
        refno:"",
        outstanding: 0,
        company_id: 0,
        payment_details:[]
    })
    const onClickCancel = () => {
      setDialogClose(false);
    };
    const onClickExit = () => {
      navigate("/");
    };
    // console.log(paymentDetails)
    const handleExit = () => {
      setDialogClose(true);
    };
    const handleSubmit = () => {
        console.log("first")
        console.log(postData)
        if(postData.supplierid === ""){
          dispatch(setSnackbar(true , "error" , "please Select the Supplier"))
        }
       else if(postData.payment_details === 0 ){
          dispatch(setSnackbar(true , "error" , "please fill amount in selected Bill"))
        }
        else if(postData.mode === null){
          dispatch(setSnackbar(true , "error" , "please select anyone payment method"))
        }else if(postData.bank === "" && postData.mode!==1){
          dispatch(setSnackbar(true , "error" , "please enter the bank name"))
        }
        else if(postData.amount === ""){
          dispatch(setSnackbar(true , "error" , "please enter the amount"))
        }
        else{
          axios.post(`/v1/payment`,postData)
          .then((res) => {
              console.log(res)
              setTimeout(()=>{
                window.location.reload();
              },1000)
            dispatch(setSnackbar(true ,"success" , "Bill Save Successfully"))
          }
            )
          .catch((err) => {console.log(err);dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))  })
        }
       
    }
    console.log(postData)
  return (
    <Grid className={classes.root}>
      <Helmet><title>Payment</title></Helmet>
      <Grid className={classes.titleInfo}>
        <Typography variant="h5" fontWeight={600}>Payment</Typography>
      </Grid>
        <Grid >
          <Grid className="border-b" sx={{height:'fit-content'}}><PaymentInfo setPostData={setPostData} postData={postData} data={data} setData={setData} /></Grid>
          <Grid className="p-2 " sx={{flex:1, height:'100%'}}><BillingTable data={data} setData={setData} code={code} setCode={setCode} ref={codeRef} setPostData={setPostData} /></Grid>
        </Grid>
        <Grid className='flex justify-center'>
            {/* <Button size="small" sx={{margin:1}} disabled startIcon={<Delete/>} variant="outlined" >Delete</Button>
            <Button size="small" sx={{margin:1}} disabled startIcon={<Print/>} variant="outlined">Print</Button>
            <Button size="small" sx={{margin:1}} disabled startIcon={<NoteAdd/>} variant="outlined" >New</Button> */}
            <Button size="small" sx={{margin:1}} startIcon={<Save/>} variant="outlined"  onClick={handleSubmit}>Save</Button>
            <Button size="small" sx={{margin:1}} startIcon={<ExitToApp />} variant="outlined" onClick={handleExit}>Exit</Button>
        </Grid>
          <DialogCancel
        onClickCancel={onClickCancel}
        onClickExit={onClickExit}
        dialogClose={dialogClose}
        setDialogClose={setDialogClose}
      />
    </Grid>
  )
}
export default Payment